import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RejectModel } from '../../../../src/app/jobseekers/shared/models/jobseeker-moderation.model';
@Component({
  selector: 'app-reject-dialog',
  templateUrl: './reject-dialog.component.html',
  styleUrls: ['./reject-dialog.component.css'],
  standalone: false,
})
export class RejectDialog {
  visible: boolean = false;
  @Input() id!: number;
  @Output() setDictionary: EventEmitter<RejectModel> =
    new EventEmitter<RejectModel>();

  showDialog() {
    this.visible = true;
  }
  setValue(visible = false, value) {
    this.setDictionary.emit({ key: this.id, value: value.value });
  }
}
